export default __webpack_public_path__ + "static/media/richard.fd96dd93.png";